import { PageBreadcrumbs } from 'src/components'
import { OrganizationalTabs } from 'src/features/organizations/components'
import { useLocales } from 'src/locales'

export const OrganizationalStructure = () => {
  const { t } = useLocales()

  return (
    <PageBreadcrumbs
      title={t('menu.organizational_structure')}
      items={[
        {
          title: t('menu.organizational_structure')
        }
      ]}
    >
      <OrganizationalTabs />
    </PageBreadcrumbs>
  )
}
